export const MOONCAKE_GIFT_SKUS = [
  'B12708',
  'B12732',
  'B12734',
  'B12735',
  'B12733',
  'B12738',
  'B12736',
  'B12739'
]

export const mooncakeRetailSkus = [
  'B12707',
  'B12708',
  'B12709',
  'B12710',
  'B12711',
  'B12712',
  'B12713',
  'B12717',
  'B12732',
  'B12733',
  'B12734',
  'B12735',
  'B12736',
  'B12737',
  'B12738',
  'B12739'
]

export const COMBO_PHUKIEN_SKU = 'V9981'

// Re-export từ promotions folder để giữ backward compatibility
export { WOMEN_8T3_MENUS } from './promotions/cake-83'
export { WOMEN_20T10_MENUS } from './promotions/cake-2010'

export const COMBO_PHUKIEN_GIFT_INFOS = [
  {
    sku: 'V10412',
    des: 'Set 12 bánh cốc Sunset Garden (mousse xoài - việt quất - sữa chua lựu)',
    giftQuantity: 1,
    endDate: '2025-11-08'
  },
  {
    sku: 'V10414',
    des: 'Set 25 bánh cốc Sunset Garden (mousse xoài - việt quất - sữa chua lựu)',
    giftQuantity: 1,
    endDate: '2025-11-08'
  },
  {
    sku: 'V10416',
    des: 'Set 36 bánh cốc Sunset Garden (mousse xoài - việt quất - sữa chua lựu)',
    giftQuantity: 2,
    endDate: '2025-11-08'
  },
  {
    sku: 'V10418',
    des: 'Set 49 bánh cốc Sunset Garden (mousse xoài - việt quất - sữa chua lựu)',
    giftQuantity: 2,
    endDate: '2025-11-08'
  },
  {
    sku: 'V8323',
    des: 'Set mousse trang trí hoa quả tươi (set 12) (size nhỏ)',
    giftQuantity: 1,
    endDate: '2025-11-08'
  },
  {
    sku: 'V8327',
    des: 'Set mousse trang trí hoa quả tươi (set 25) (size vừa)',
    giftQuantity: 1,
    endDate: '2025-11-08'
  },
  {
    sku: 'V10304',
    des: 'Set mousse trang trí hoa quả tươi (set 36) (size to)',
    giftQuantity: 2,
    endDate: '2025-11-08'
  },
  {
    sku: 'V10305',
    des: 'Set mousse trang trí hoa quả tươi (set 49) (size to)',
    giftQuantity: 2,
    endDate: '2025-11-08'
  },
  //
  {
    sku: 'V10333',
    des: 'Bánh kem Bouquet Flowers size nhỏ (hộp mica)',
    giftQuantity: 1,
    endDate: '2025-11-15'
  },
  {
    sku: 'V10334',
    des: 'Bánh kem Bouquet Flowers size vừa (hộp mica)',
    giftQuantity: 1,
    endDate: '2025-11-15'
  },
  {
    sku: 'V10336',
    des: 'Set 20 bánh su kem Bouquet Flowers (size nhỏ)',
    giftQuantity: 1,
    endDate: '2025-11-15'
  },
  {
    sku: 'V10337',
    des: 'Set 30 bánh su kem Bouquet Flowers (size vừa)',
    giftQuantity: 1,
    endDate: '2025-11-15'
  }
]
